import React from "react";
import { Table, Typography } from "antd";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import moment from "moment";
import { useQuery } from "react-query";
import Employee from "../../../components/tables/Employee";
import Date from "../../../components/tables/Date";
import { listScheduling } from "../../../api/server";
import { getFullName } from "../../../components/util/helpers";
import SchedulingPopoverWrapper from "./SchedulingPopover.style";

const { Text, Title } = Typography;

const SchedulingPopover = ({ startDate, endDate, patient }) => {
  const scopePrefix = useSelector((state) => state.user.scopePrefix);
  const name = getFullName(patient?.surename, patient?.first_name);
  const intl = useIntl();

  const listParams = {
    current: 1,
    pageSize: 100,
    query: {
      from: startDate,
      to: endDate,
    },
    scopePrefix,
    patientId: patient?.id,
  };

  const fetchScheduling = async () => {
    if (startDate && endDate && patient?.id) {
      const scheduling = await listScheduling(listParams);
      const { items } = scheduling.data;
      return items;
    }
    throw new Error("Missing parameters");
  };

  const {
    data = [],
    isLoading: loading,
    error,
  } = useQuery(["scheduling", listParams], fetchScheduling);

  if (error) {
    console.error("An error occurred while fetching scheduling data:", error);
  }
  const columns = [
    {
      title: intl.formatMessage({
        id: "app.scheduling.table.employee",
      }),
      dataIndex: "employee",
      render: (text, record) => {
        return text ? <Employee record={text} /> : null;
      },
      width: "220px",
    },
    {
      title: intl.formatMessage({
        id: "app.scheduling.table.client_name",
      }),
      dataIndex: "client_name",
      render: (text, record) => {
        return <Text>{text}</Text>;
      },
      width: "100px",
    },

    {
      title: intl.formatMessage({
        id: "app.scheduling.table.schedulingDayInWeek",
      }),
      dataIndex: "date",
      render: (text, record) => {
        return <Text>{moment.weekdays(moment(text).weekday())}</Text>;
      },
      width: "100px",
    },
    {
      title: intl.formatMessage({
        id: "app.scheduling.table.schedulingStartHour",
      }),
      dataIndex: "date",
      render: (text) => {
        return <Date text={text} format="HH:mm" />;
      },
      width: "100px",
    },
    {
      title: intl.formatMessage({
        id: "app.scheduling.table.schedulingEndHour",
      }),
      dataIndex: "date",
      width: "100px",
      render: (text, record) => {
        const endTime = moment(text).add(record.duration_minutes, "minutes");
        return <Date text={endTime} format="HH:mm" />;
      },
    },
  ];

  return (
    <SchedulingPopoverWrapper className="schedulingPopover">
      <div className="schedulingHeader">
        <Title className="schedulingTitle" level={2}>
          {`${intl.formatMessage({
            id: "app.scheduling.schedulingOfPatient",
          })} ${name}`}
        </Title>
        <Title className="schedulingSubTitle" level={5}>
          {`${intl.formatMessage({
            id: "app.scheduling.date",
          })}: ${moment(startDate).format("DD/MM/YYYY")}`}
        </Title>
      </div>
      <div className="schedulingTableWrapper">
        <Table
          bordered
          dataSource={data}
          columns={columns}
          pagination={false}
          rowKey={(record) => record.id}
          scroll={{ y: window.innerHeight / 2 }}
          loading={loading}
        />
      </div>
    </SchedulingPopoverWrapper>
  );
};

export default SchedulingPopover;
